<div class="container-fluid">
  <div class="row mb-1" *ngIf="!isFromListingPage">
    <h4 class="page-title common-bene-class-for-translation"> Manage Petitions</h4>
  </div>
  <div *ngIf="newPetitionCount>0" class="notification mb-4">
    <div class="notice">
      <mat-icon matPrefix>warning</mat-icon>
      <span> {{newPetitionCount}} <span class="common-bene-class-for-translation">new petition added by </span> {{ this.newPetitionCompanyName}} </span>
    </div>
  </div>

  <div class="content-container pl-0 pr-0 pt-3 pb-1">
    <div class="row mb-2">
      <div class="col-md-{{!isFromListingPage ? 9 : 4}} pt-1 pull-right ">
        <label class="view-label common-bene-class-for-translation">View By </label>
        <p-dropdown class="filter-dropdown" [style]="{width: '250px'}" [options]="taskType" optionValue="code"
          [(ngModel)]="filter.superTaskType" (onChange)="getSubTaskType();" optionLabel="name">
        </p-dropdown>
      </div>
      <div class="col-md-3 search-btn pull-right" [ngClass]="{'pl-0': isFromListingPage}">
        <div class="input-group search-text" [ngClass]="{'w-100 pt-1': isFromListingPage}">
          <input class="form-control im-pt-3 pr-5" #searchBeneficiaryListTable (search)="resetSearch()" type="search"
            placeholder="Search {{!isFromListingPage ? 'Beneficiary / ' :''}}Company">
          <span class="input-group-append">
            <button class="btn rounded-pill ml-n4r" id="SearchBeneficiary" aria-label="Search Beneficiary / Company"
              type="button">
              <i class="fa fa-search border-0"></i>
            </button>
          </span>
        </div>
        <!-- <div class="search-box pull-right" role="search">
          <input placeholder="Search" name="petition-srch-term" class="search-input" id="srch-term" type="text"
          #searchBeneficiaryListTable (search)="applySearchFilter()">
          <mat-icon matTooltip="Search a petition" class="search-icon" matSuffix>search</mat-icon>
        </div> -->
      </div>
      <div class="col-md-5 d-flex justify-content-end" *ngIf="isFromListingPage">
        <button type="button" pButton (click)="addNewTask()"><span class="common-bene-class-for-translation">Create Task </span></button>
      </div>
    </div>

    <div class="row no-gutters">
      <div class="col-12">
        <p-table [columns]="cols" class="pa-table im-card-no-border-table im-card-table-noborder-spacing table"
          styleClass="p-datatable-gridlines" [value]="taskList" dataKey="id" *ngIf="taskList?.length > 0">
          <ng-template pTemplate="header" let-columns>
            <tr class="text-uppercase">
              <th *ngFor="let col of columns" class="common-bene-class-for-translation">
                {{col.header}}
              </th>
              <th class="common-bene-class-for-translation">Action </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-task let-rowIndex="rowIndex" let-columns="columns">
            <tr>
              <td *ngFor="let col of columns ; index as i">
                <span *ngIf="col.field === 'beneficiaryName'">
                  <ng-template [ngIf]="task['beneficiaryId']">
                    {{task['beneficiaryFirstName']}} {{task['beneficiaryLastName']}}
                  </ng-template>
                  <ng-template [ngIf]="task['sponsorId'] && !task.benInitFamilyId">
                    {{task['sponsorFirstName']}} {{task['sponsorLastName']}}
                  </ng-template>
                </span>
                <span *ngIf="col.field === 'status'">
                  {{task['taskStatusId']['name']}}
                </span>
                <span *ngIf="col.field === 'companyName'">
                  {{task['companyName'] ? task['companyName'] : '&mdash;' }}
                </span>
                <span *ngIf="col.field !== 'beneficiaryName' && col.field !== 'status' &&
                col.field !== 'companyName'">
                  {{task[col.field]}}
                </span>
              </td>

              <td>
                <!-- <div
                  [pTooltip]="task['isBeneficiaryVisible'] ? '' : 'You do not have view access permission from your company'">
                  <button pButton type="button" icon="pi pi-pencil" (click)="handleTask(task.id)"
                    [pTooltip]="task['isBeneficiaryVisible'] ? 'Edit this task' : 'You do not have view access permission from your company'"
                    [disabled]="!task['isBeneficiaryVisible']" class="p-button-text"></button>
                </div> -->
                <mat-icon matTooltip="settings menu" class="mr-1 icn settingsBorder" [matMenuTriggerFor]="menu">
                  <mat-icon>settings</mat-icon>
                  <mat-icon>keyboard_arrow_down</mat-icon>
                </mat-icon>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item  [pTooltip]="task['isBeneficiaryVisible'] || userType !=='Beneficiary' ? '' : 'You do not have view access permission from your company'"
                  [disabled]="!task['isBeneficiaryVisible'] && !isFromListingPage" (click)="handleTask(task)"><span class="common-bene-class-for-translation">Edit</span></button>
                  <button *ngIf="task['isRequestedDocuments']" mat-menu-item (click)="handleDocList(task)"><span class="common-bene-class-for-translation">Requested Documents List</span> <i class="pl-1 pi pi-exclamation-triangle"></i></button>
                  <button mat-menu-item (click)="handleDeleteSuperTask(task.id)" *ngIf="['PETITIONINPROGRESS','PETITIONNEW'].includes(task?.taskStatusId?.code) && isFromListingPage"><span class="common-bene-class-for-translation">Delete</span></button>
                </mat-menu>
                <i *ngIf="task['isRequestedDocuments']" matTooltip="Documents Requested" class="pi pi-exclamation-triangle pl-1 outside-menu"></i>
              </td>
            </tr>
          </ng-template>
        </p-table>
        <div class="text-center mt-2 p-2" *ngIf="taskList?.length == 0">
          No Records
        </div>
      </div>
    </div>
  </div>
</div>
